import Pagination from '../Pagination'
import React, { useMemo } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import copy from '../../assets/icons/copy.svg'
import edit from '../../assets/icons/edit.svg'
import trash from '../../assets/icons/trashRed.svg'
import { useDispatch, useSelector } from 'react-redux';
import {deleteWaliKelas, getWaliKelas,  updateStateWaliKelas} from '../../features/waliKelasSlice';

import imgErrorValidation from '../../utils/imgErrorValidation';
import arrowDownIcon from '../../assets/icons/arrow-right.svg'
import orangImage from '../../assets/images/user-foto.png'
import AlertModal from '../AlertModal';
import { useState } from 'react';

let PageSize = 10;

function Table() {
    const { listWaliKelas, isLoading, urutan, currentPage } = useSelector(state => state.waliKelas)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [alertModalDelete, setAlertModalDelete] = useState(false)
    const [idUserToDelete, setIdUserToDelete] = useState(null)

    const currentSiswaTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;

        const sortedData = [...listWaliKelas].sort((a, b) => {
            if (urutan.column === 'nama') {
                return urutan.order === 'asc'
                    ? a.nama.localeCompare(b.nama)
                    : b.nama.localeCompare(a.nama);
            } else if (urutan.column === 'niy') {
                return urutan.order === 'asc'
                    ? parseInt(a.niy) - parseInt(b.niy)
                    : parseInt(b.niy) - parseInt(a.niy);
            }
        });

        return sortedData?.slice(firstPageIndex, lastPageIndex);
    }, [isLoading, listWaliKelas, urutan, currentPage]);

    function handleDetail(id) {
        navigate(`/karyawan/edit/${id}`)
    }

    function handleDelete(id) {
        dispatch(deleteWaliKelas(id))
            .then((res) => {
                const totalItems = listWaliKelas.length - 1;
                const lastItemOnPage = totalItems % PageSize === 0;
                if (lastItemOnPage && currentPage > 1) {
                    dispatch(updateStateWaliKelas({ name: 'currentPage', value: 1 }));
                }

                if (res.meta.requestStatus === 'fulfilled') {

                }
                dispatch(getWaliKelas({}))
            })
    }

    function handleCopyNiy(niy) {
        navigator.clipboard.writeText(niy)
    }

    function handleSort(column) {
        if (urutan.column === column) {
            dispatch(
                updateStateWaliKelas({
                    name: 'urutan',
                    value: {
                        column,
                        order: urutan.order === 'asc' ? 'desc' : 'asc'
                    }
                })
            )
        } else {
            dispatch(
                updateStateWaliKelas({
                    name: 'urutan',
                    value: {
                        column,
                        order: 'asc'
                    }
                })
            )
        }
    }



    return (
        <>
            <table className='table'>
                <thead>
                <tr>
                    <th className='th-niy'>
                        <div className='wrap-filter'>
                            NIY
                            <img src={arrowDownIcon} alt=""
                                 onClick={() => handleSort('niy')}
                                 className={urutan.column === 'niy' && urutan.order === 'asc' ? 'arrow-up' : 'arrow-down'}
                            />
                        </div>
                    </th>
                    <th className='th-name'>
                        <div className='wrap-filter'>
                            Nama Wali Kelas
                            <img src={arrowDownIcon} alt="" onClick={() => handleSort('nama')}
                                 className={urutan.column === 'nama' && urutan.order === 'asc' ? 'arrow-up' : 'arrow-down'}
                            />
                        </div>
                    </th>
                    <th className='th-jabatan'>Jabatan</th>
                    <th className='th-jabatan'>Kelas</th>

                </tr>
                </thead>

                <tbody>
                {
                    isLoading ? <tr className='loading loading-table'><td>loading...</td></tr>
                        : currentSiswaTableData.length === 0 ? <tr className='loading-table'><td>Data tidak ditemukan</td></tr> :
                            currentSiswaTableData?.map((item, key) => {
                                return (
                                    <tr key={key}>
                                        <td className='niy-col'>{item?.niy}</td>
                                        <td className='row-img'>
                                            <img src={orangImage} onError={imgErrorValidation} alt="" />
                                            {item?.nama}
                                        </td>


                                        <td>{item?.jabatan}</td>
                                        <td>{item?.kelas}</td>


                                        <td className='action-col'>
                                            <div>
                                                <img src={copy} alt='' onClick={() => handleCopyNiy(item?.niy)} />
                                                <Link to={`/wali-kelas/edit/${item?.id}`}>
                                                    <img src={edit} alt="" />
                                                </Link>
                                                <img src={trash} alt='' onClick={() => {
                                                    setAlertModalDelete(true)
                                                    setIdUserToDelete(item.id)
                                                }}
                                                />
                                            </div>
                                        </td>


                                    </tr>
                                )
                            })
                }
                </tbody>
            </table>

            {!isLoading &&
                <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={listWaliKelas?.length}
                    pageSize={PageSize}
                    onPageChange={page =>
                        dispatch(updateStateWaliKelas({ name: 'currentPage', value: page }))
                    }
                />
            }

            {alertModalDelete && <AlertModal
                heading={'Hapus Siswa'}
                message={'Apakah anda yakin ingin menghapus siswa ini?'}
                onCancel={() => setAlertModalDelete(false)}
                onConfirm={() => handleDelete(idUserToDelete)}
            />}
        </>
    )
}

export default Table